﻿[
  {
    "draftJersey": "001",
    "name": "Ainoa Montoya",
    "age": 27,
    "foot": "right",
    "height": 167,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/001.jpg",
    "macros": {
      "talent": 77,
      "defence": 96,
      "attack": 80,
      "positioning": 80,
      "average": 83
    },
    "profileYtVideoId": "KQxQtTgjGRY",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "002",
    "name": "Ana Mayoral",
    "age": 21,
    "foot": "right",
    "height": 155,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/002.jpg",
    "macros": {
      "talent": 88,
      "defence": 78,
      "attack": 90,
      "positioning": 80,
      "average": 84
    },
    "profileYtVideoId": "27AcRWp_KXE",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "005",
    "name": "Elvira Pech",
    "age": 28,
    "foot": "right",
    "height": 159,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/005.jpg",
    "macros": {
      "talent": 61,
      "defence": 72,
      "attack": 55,
      "positioning": 70,
      "average": 65
    },
    "profileYtVideoId": "rwwmOdteciE",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "007",
    "name": "Paula Blas",
    "age": 24,
    "foot": "right",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/007.jpg",
    "macros": {
      "talent": 72,
      "defence": 54,
      "attack": 78,
      "positioning": 70,
      "average": 69
    },
    "profileYtVideoId": "WznFZJGPHpc",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "008",
    "name": "Ainhoa Adame",
    "age": 27,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/008.jpg",
    "macros": {
      "talent": 70,
      "defence": 30,
      "attack": 85,
      "positioning": 80,
      "average": 66
    },
    "profileYtVideoId": "07jctiVnlZg",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "009",
    "name": "Alicia Arévalo",
    "age": 24,
    "foot": "left",
    "height": 158,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/009.jpg",
    "macros": {
      "talent": 100,
      "defence": 90,
      "attack": 95,
      "positioning": 90,
      "average": 94
    },
    "profileYtVideoId": "FyfVEzAl7FM",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "010",
    "name": "Camila Marqués",
    "age": 28,
    "foot": "right",
    "height": 158,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/010.jpg",
    "macros": {
      "talent": 65,
      "defence": 60,
      "attack": 80,
      "positioning": 80,
      "average": 71
    },
    "profileYtVideoId": "C3pFrOaHdZI",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "011",
    "name": "Carolina Pablos",
    "age": 24,
    "foot": "right",
    "height": 166,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/011.jpg",
    "macros": {
      "talent": 50,
      "defence": 44,
      "attack": 50,
      "positioning": 40,
      "average": 46
    },
    "profileYtVideoId": "5NXqfOvv1KI",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "014",
    "name": "Maria Brau",
    "age": 29,
    "foot": "left",
    "height": 173,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/014.jpg",
    "macros": {
      "talent": 50,
      "defence": 50,
      "attack": 75,
      "positioning": 70,
      "average": 61
    },
    "profileYtVideoId": "yql6yqFuafU",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "015",
    "name": "María Inés Balde",
    "age": 28,
    "foot": "left",
    "height": 169,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/015.jpg",
    "macros": {
      "talent": 50,
      "defence": 70,
      "attack": 61,
      "positioning": 60,
      "average": 60
    },
    "profileYtVideoId": "kkjsTm1Nw3s",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "016",
    "name": "Txell Gilabert",
    "age": 22,
    "foot": "right",
    "height": 159,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/016.jpg",
    "macros": {
      "talent": 95,
      "defence": 90,
      "attack": 95,
      "positioning": 90,
      "average": 93
    },
    "profileYtVideoId": "SBTbZmmhK_c",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "019",
    "name": "Emma Dahlmann",
    "age": 24,
    "foot": "right",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/019.jpg",
    "macros": {
      "talent": 55,
      "defence": 50,
      "attack": 63,
      "positioning": 50,
      "average": 55
    },
    "profileYtVideoId": "MiHmH2tuzxg",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "020",
    "name": "Ester Martínez",
    "age": 33,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/020.jpg",
    "macros": {
      "talent": 45,
      "defence": 50,
      "attack": 50,
      "positioning": 50,
      "average": 49
    },
    "profileYtVideoId": "oTam4ugg-6U",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "022",
    "name": "Mónica Chapinal",
    "age": 37,
    "foot": "left",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/022.jpg",
    "macros": {
      "talent": 85,
      "defence": 70,
      "attack": 80,
      "positioning": 90,
      "average": 81
    },
    "profileYtVideoId": "a2ybvm-rNMA",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "024",
    "name": "Tania Moyano",
    "age": 27,
    "foot": "left",
    "height": 164,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/024.jpg",
    "macros": {
      "talent": 65,
      "defence": 60,
      "attack": 80,
      "positioning": 70,
      "average": 69
    },
    "profileYtVideoId": "PgJGALaW3a4",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "025",
    "name": "Laura Alegría",
    "age": 23,
    "foot": "right",
    "height": 172,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/025.jpg",
    "macros": {
      "talent": 72,
      "defence": 96,
      "attack": 65,
      "positioning": 70,
      "average": 76
    },
    "profileYtVideoId": "Ra7zt3g5HWM",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "028",
    "name": "Maria Llobet",
    "age": 26,
    "foot": "right",
    "height": 155,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/028.jpg",
    "macros": {
      "talent": 40,
      "defence": 55,
      "attack": 40,
      "positioning": 40,
      "average": 44
    },
    "profileYtVideoId": "DSwWw2FEYl8",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "031",
    "name": "Beatriz Pérez",
    "age": 22,
    "foot": "left",
    "height": 165,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/031.jpg",
    "macros": {
      "talent": 55,
      "defence": 60,
      "attack": 55,
      "positioning": 50,
      "average": 55
    },
    "profileYtVideoId": "gxTk2x8Cmf8",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "032",
    "name": "Kiara Ribas",
    "age": 22,
    "foot": "right",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/032.jpg",
    "macros": {
      "talent": 60,
      "defence": 55,
      "attack": 72,
      "positioning": 55,
      "average": 61
    },
    "profileYtVideoId": "bQahAr0iP3w",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "046",
    "name": "Marta Espinosa",
    "age": 20,
    "foot": "right",
    "height": 172,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/046.jpg",
    "macros": {
      "talent": 61,
      "defence": 66,
      "attack": 55,
      "positioning": 70,
      "average": 63
    },
    "profileYtVideoId": "9O4t5NcwZ14",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "051",
    "name": "Ángela Barroso",
    "age": 26,
    "foot": "right",
    "height": 163,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/051.jpg",
    "macros": {
      "talent": 72,
      "defence": 90,
      "attack": 75,
      "positioning": 80,
      "average": 79
    },
    "profileYtVideoId": "RJWa4ZCyqjw",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "052",
    "name": "Carmen Cazalla",
    "age": 22,
    "foot": "left",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/052.jpg",
    "macros": {
      "talent": 61,
      "defence": 60,
      "attack": 55,
      "positioning": 60,
      "average": 59
    },
    "profileYtVideoId": "_VjhqdtQuSI",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "053",
    "name": "Elena Espinosa",
    "age": 21,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/053.jpg",
    "macros": {
      "talent": 83,
      "defence": 96,
      "attack": 70,
      "positioning": 80,
      "average": 82
    },
    "profileYtVideoId": "RnMFhsprm4Y",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "054",
    "name": "Marta Pou",
    "age": 35,
    "foot": "right",
    "height": 170,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/054.jpg",
    "macros": {
      "talent": 77,
      "defence": 90,
      "attack": 70,
      "positioning": 80,
      "average": 79
    },
    "profileYtVideoId": "_xWA2Z5MlMc",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "056",
    "name": "Sara García",
    "age": 33,
    "foot": "right",
    "height": 160,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/056.jpg",
    "macros": {
      "talent": 50,
      "defence": 72,
      "attack": 55,
      "positioning": 70,
      "average": 62
    },
    "profileYtVideoId": "yFc8Kdhxt1U",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "057",
    "name": "Sara Cobollo",
    "age": 23,
    "foot": "right",
    "height": 164,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/057.jpg",
    "macros": {
      "talent": 50,
      "defence": 60,
      "attack": 70,
      "positioning": 60,
      "average": 60
    },
    "profileYtVideoId": "lGHuyxUccwk",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "058",
    "name": "Andrea Granados",
    "age": 27,
    "foot": "left",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/058.jpg",
    "macros": {
      "talent": 80,
      "defence": 85,
      "attack": 80,
      "positioning": 70,
      "average": 79
    },
    "profileYtVideoId": "eYCp8_mRqF4",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "059",
    "name": "Andrea Pueyo",
    "age": 24,
    "foot": "right",
    "height": 167,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/059.jpg",
    "macros": {
      "talent": 80,
      "defence": 65,
      "attack": 65,
      "positioning": 70,
      "average": 70
    },
    "profileYtVideoId": "7PHKc0jxuJo",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "060",
    "name": "Céline Ramos",
    "age": 19,
    "foot": "left",
    "height": 165,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/060.jpg",
    "macros": {
      "talent": 70,
      "defence": 60,
      "attack": 80,
      "positioning": 70,
      "average": 70
    },
    "profileYtVideoId": "C9jpMyGzUgc",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "061",
    "name": "Claudia Sánchez",
    "age": 20,
    "foot": "right",
    "height": 162,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/061.jpg",
    "macros": {
      "talent": 55,
      "defence": 60,
      "attack": 61,
      "positioning": 50,
      "average": 57
    },
    "profileYtVideoId": "8aZTXiaYnTM",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "062",
    "name": "Lívia Martínez",
    "age": 21,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/062.jpg",
    "macros": {
      "talent": 80,
      "defence": 80,
      "attack": 80,
      "positioning": 80,
      "average": 80
    },
    "profileYtVideoId": "jhlk08tGB8Q",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "063",
    "name": "Mar Dalmau",
    "age": 20,
    "foot": "right",
    "height": 159,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/063.jpg",
    "macros": {
      "talent": 65,
      "defence": 70,
      "attack": 70,
      "positioning": 70,
      "average": 69
    },
    "profileYtVideoId": "EbPYTL1KPI4",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "064",
    "name": "Mireia Barranqueras",
    "age": 30,
    "foot": "right",
    "height": 151,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/064.jpg",
    "macros": {
      "talent": 50,
      "defence": 45,
      "attack": 55,
      "positioning": 50,
      "average": 50
    },
    "profileYtVideoId": "iJ4I_GlWdu0",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "065",
    "name": "Olga Gómez",
    "age": 24,
    "foot": "right",
    "height": 163,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/065.jpg",
    "macros": {
      "talent": 70,
      "defence": 85,
      "attack": 80,
      "positioning": 80,
      "average": 79
    },
    "profileYtVideoId": "Kbnaqgnk748",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "066",
    "name": "Anna Servià",
    "age": 32,
    "foot": "right",
    "height": 167,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/066.jpg",
    "macros": {
      "talent": 70,
      "defence": 70,
      "attack": 70,
      "positioning": 60,
      "average": 68
    },
    "profileYtVideoId": "bapRdioAUD4",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "067",
    "name": "Carla Martínez",
    "age": 30,
    "foot": "right",
    "height": 161,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/067.jpg",
    "macros": {
      "talent": 75,
      "defence": 75,
      "attack": 70,
      "positioning": 80,
      "average": 75
    },
    "profileYtVideoId": "b-e6ijelsbY",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "068",
    "name": "Ivette Fabregat",
    "age": 25,
    "foot": "right",
    "height": 159,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/068.jpg",
    "macros": {
      "talent": 50,
      "defence": 55,
      "attack": 63,
      "positioning": 60,
      "average": 57
    },
    "profileYtVideoId": "6-HbnpOisWQ",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "069",
    "name": "Lidia Rubio",
    "age": 28,
    "foot": "right",
    "height": 173,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/069.jpg",
    "macros": {
      "talent": 60,
      "defence": 65,
      "attack": 85,
      "positioning": 60,
      "average": 68
    },
    "profileYtVideoId": "uFLbl6iw_Ho",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "070",
    "name": "María Herrera",
    "age": 25,
    "foot": "right",
    "height": 159,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/070.jpg",
    "macros": {
      "talent": 65,
      "defence": 60,
      "attack": 75,
      "positioning": 80,
      "average": 70
    },
    "profileYtVideoId": "khFu4szoYYA",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "072",
    "name": "Paula Nieto",
    "age": 18,
    "foot": "right",
    "height": 163,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/072.jpg",
    "macros": {
      "talent": 75,
      "defence": 90,
      "attack": 70,
      "positioning": 70,
      "average": 76
    },
    "profileYtVideoId": "RZP-aYuKdYo",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "073",
    "name": "Ylenia Cirrincione",
    "age": 23,
    "foot": "right",
    "height": 173,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/073.jpg",
    "macros": {
      "talent": 50,
      "defence": 50,
      "attack": 70,
      "positioning": 50,
      "average": 55
    },
    "profileYtVideoId": "TrotM4PfNf0",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "075",
    "name": "Carla Calvo",
    "age": 21,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/075.jpg",
    "macros": {
      "talent": 75,
      "defence": 80,
      "attack": 70,
      "positioning": 80,
      "average": 76
    },
    "profileYtVideoId": "Gs005S_h344",
    "matchYtVideoId": "8PTQPlZDOYM"
  },
  {
    "draftJersey": "076",
    "name": "Alba Ortiz",
    "age": 22,
    "foot": "right",
    "height": 160,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/076.jpg",
    "macros": {
      "talent": 50,
      "defence": 60,
      "attack": 70,
      "positioning": 60,
      "average": 60
    },
    "profileYtVideoId": "pu_D3aPOx2c",
    "matchYtVideoId": "LPU3e3etB5I"
  },
  {
    "draftJersey": "077",
    "name": "Laura Rodríguez",
    "age": 21,
    "foot": "left",
    "height": 168,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/077.jpg",
    "macros": {
      "talent": 44,
      "defence": 44,
      "attack": 50,
      "positioning": 40,
      "average": 45
    },
    "profileYtVideoId": "aJ44TAQU69o",
    "matchYtVideoId": "7YrXTAnvOn0"
  },
  {
    "draftJersey": "079",
    "name": "Maria Cabal",
    "age": 22,
    "foot": "right",
    "height": 162,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/079.jpg",
    "macros": {
      "talent": 65,
      "defence": 80,
      "attack": 95,
      "positioning": 80,
      "average": 80
    },
    "profileYtVideoId": "Om3UjeGNcj0",
    "matchYtVideoId": "qsZ2BIM5CBA"
  },
  {
    "draftJersey": "081",
    "name": "Tania Torrecabota",
    "age": 37,
    "foot": "right",
    "height": 155,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823-ql/081.jpg",
    "macros": {
      "talent": 85,
      "defence": 80,
      "attack": 80,
      "positioning": 80,
      "average": 81
    },
    "profileYtVideoId": "QUHdL9fbf_4",
    "matchYtVideoId": "qsZ2BIM5CBA"
  }
]
